module.exports = "/dist/16e1d930cf13fb7a956372044b6d02d0.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-400.woff
// module id = 152
// module chunks = 0